import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import Fila from "./Fila";
import styles from "./styles";

const enhance = compose(withStyles(styles));

export default enhance(Fila);
